// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/whenIdle.ts
import { onHidden } from './onHidden';
export var whenIdle = function whenIdle(cb) {
  var rIC = window.requestIdleCallback || window.setTimeout;
  var handle = -1;
  cb = runOnce(cb);
  // If the document is hidden, run the callback immediately, otherwise
  // race an idle callback with the next `visibilitychange` event.
  if (document.visibilityState === 'hidden') {
    cb();
  } else {
    var cleanup = onHidden(function () {
      cb();
      cleanup();
    });
    handle = rIC(function () {
      cb();
      cleanup();
    });
  }
  return handle;
};

// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/runOnce.ts
var runOnce = function runOnce(cb) {
  var called = false;
  return function () {
    if (!called) {
      cb();
      called = true;
    }
  };
};